import Cookies from 'js-cookie';
import { COOKIES } from '../config/cookies';
import { ShopifyStorefrontClient } from '../api/shopify/ShopifyStorefrontClient';
import { getPrimaryItem } from './cartApi';
import { JbCart } from '@jbhi-fi/apis/src/shopify/types/JbCart';

const storefrontClient = new ShopifyStorefrontClient();

export const fixInvalidCart = async (cart: JbCart) => {
  // Check for orphaned services
  const cartServices = cart.items.filter(item => item.properties._isAttachedService === 'true');
  const orphanedServices = cartServices.filter(item => !getPrimaryItem(cart.items, item.properties._serviceLink));
  for (const orphanedService of orphanedServices) {
    await storefrontClient.removeFromCart(orphanedService.line_id);
  }

  // App insights logging to investigate big carts
  if (cart.item_count > 50) {
    const cartSummary = cart.items.reduce((acc: { [key: string]: { quantity: number; name: string } }, item) => {
      if (acc[item.sku]) {
        acc[item.sku].quantity += item.quantity;
      } else {
        acc[item.sku] = {
          quantity: item.quantity,
          name: item.product_title,
        };
      }
      return acc;
    }, {});
    window.appInsights?.trackEvent({
      name: 'Big Cart Quantity',
      properties: {
        riskifiedToken: Cookies.get(COOKIES.RISKIFIED_TOKEN),
        totalCartLines: cart.items.length.toString(),
        totalCartQuantity: cart.item_count.toString(),
        totalCartCost: (cart.total_price / 100).toFixed(2),
        cartSummary: JSON.stringify(cartSummary),
      },
    });
  }

  // If any line has more than the max quantity, reset the quantity to the max
  let newCart = cart;
  const maxQtyIssueItems = [];
  for (const item of cart.items) {
    const maxQty = Number(item.properties._maxQty) || 5;
    if (item.quantity > maxQty) {
      const updatedCart = await storefrontClient.updateCartLine(item.line_id, maxQty);
      if (updatedCart) {
        newCart = updatedCart;
      }
      maxQtyIssueItems.push({
        sku: item.sku,
        name: item.product_title,
        oldQuantity: item.quantity,
        newQuantity: maxQty,
      });
    }
  }

  // App insights logging to investigate max quantity issues
  if (maxQtyIssueItems.length) {
    window.appInsights?.trackEvent({
      name: 'Cart Max Quantity Issue',
      properties: {
        riskifiedToken: Cookies.get(COOKIES.RISKIFIED_TOKEN),
        cart: JSON.stringify(maxQtyIssueItems),
      },
    });
  }

  return newCart;
};
